module.exports = __webpack_public_path__ + "img/bg-1440.c37136ec.webp";